export const contentTableConfig = {
  title: '敏感词管理',
  propList: [
    { prop: 'category', label: '类别', minWidth: '80',slotName: 'category'},
    { prop: 'content', label: '敏感词', minWidth: '100' },
    { prop: 'description', label: '描述', minWidth: '80' },
    {
      label: '操作',
      minWidth: '120',
      slotName: 'handler'
    }
  ],
  showSelectColumn: false,
}